import { Navigate, Route, Routes } from 'react-router-dom'
import AgentActivityLogs from './AgentActivityLogs'

export default function AgentActivityLogsRoutes() {
    return (
        <Routes>
            <Route index element={<AgentActivityLogs />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
